import articles from '../../data/articles';
import './relatedArticles.css';

function RelatedArticles({
  bookSlug,
  bgColor = '#faf3e7',
  titleColor = '#2c2620',
  textColor = '#2c2620',
  cardBg = 'rgba(255,255,255,0.08)',
}) {
  const relatedArticles = articles.filter((article) => article.tags.includes(bookSlug));

  if (relatedArticles.length === 0) return null;

  return (
    <section
      className="related-articles-section"
      style={{
        '--ra-bg': bgColor,
        '--ra-title': titleColor,
        '--ra-text': textColor,
        '--ra-card-bg': cardBg,
      }}
    >
      <h2 className="related-articles-title">More Reflections</h2>
      <div className="related-articles-grid">
        {relatedArticles.map((article) => (
          <a key={article.slug} href={article.url} target="_blank" rel="noopener noreferrer" className="related-article-card">
            <div>
              <span className="related-article-readtime">{article.readTime}</span>
              <h3 className="related-article-heading">{article.title}</h3>
              <p className="related-article-excerpt">{article.excerpt}</p>
            </div>
            <span className="related-article-link">Read on Medium →</span>
          </a>
        ))}
      </div>
    </section>
  );
}

export default RelatedArticles;